/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Section_Steps_LeadInputs */

const en_home_section_steps_lead = /** @type {(inputs: Home_Section_Steps_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Six steps.`)
};

const es_home_section_steps_lead = /** @type {(inputs: Home_Section_Steps_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seis pasos.`)
};

const de_home_section_steps_lead = /** @type {(inputs: Home_Section_Steps_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sechs Schritte.`)
};

const zh_home_section_steps_lead = /** @type {(inputs: Home_Section_Steps_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`六个步骤。`)
};

const ar_home_section_steps_lead = /** @type {(inputs: Home_Section_Steps_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ست خطوات.`)
};

const fr_home_section_steps_lead = /** @type {(inputs: Home_Section_Steps_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Six étapes.`)
};

const vi_home_section_steps_lead = /** @type {(inputs: Home_Section_Steps_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sáu bước.`)
};

const sw_home_section_steps_lead = /** @type {(inputs: Home_Section_Steps_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hatua sita.`)
};

const th_home_section_steps_lead = /** @type {(inputs: Home_Section_Steps_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หกขั้นตอน`)
};

const bs_home_section_steps_lead = /** @type {(inputs: Home_Section_Steps_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šest koraka.`)
};

const ja_home_section_steps_lead = /** @type {(inputs: Home_Section_Steps_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6つのステップ。`)
};

const ko_home_section_steps_lead = /** @type {(inputs: Home_Section_Steps_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6단계.`)
};

const pt_home_section_steps_lead = /** @type {(inputs: Home_Section_Steps_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seis passos.`)
};

const it_home_section_steps_lead = /** @type {(inputs: Home_Section_Steps_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sei passi.`)
};

const sv_home_section_steps_lead = /** @type {(inputs: Home_Section_Steps_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sex steg.`)
};

const nl_home_section_steps_lead = /** @type {(inputs: Home_Section_Steps_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zes stappen.`)
};

const da_home_section_steps_lead = /** @type {(inputs: Home_Section_Steps_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seks skridt.`)
};

const nb_home_section_steps_lead = /** @type {(inputs: Home_Section_Steps_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seks skritt.`)
};

const fi_home_section_steps_lead = /** @type {(inputs: Home_Section_Steps_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuusi askelta.`)
};

const pl_home_section_steps_lead = /** @type {(inputs: Home_Section_Steps_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sześć kroków.`)
};

const ru_home_section_steps_lead = /** @type {(inputs: Home_Section_Steps_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Шесть шагов.`)
};

const tr_home_section_steps_lead = /** @type {(inputs: Home_Section_Steps_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altı adım.`)
};

const hi_home_section_steps_lead = /** @type {(inputs: Home_Section_Steps_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`छह चरण`)
};

const id_home_section_steps_lead = /** @type {(inputs: Home_Section_Steps_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enam langkah.`)
};

const ms_home_section_steps_lead = /** @type {(inputs: Home_Section_Steps_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enam langkah.`)
};

const cs_home_section_steps_lead = /** @type {(inputs: Home_Section_Steps_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šest kroků.`)
};

const el_home_section_steps_lead = /** @type {(inputs: Home_Section_Steps_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Έξι βήματα.`)
};

const he_home_section_steps_lead = /** @type {(inputs: Home_Section_Steps_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שישה צעדים`)
};

const af_home_section_steps_lead = /** @type {(inputs: Home_Section_Steps_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ses stappe.`)
};

const hu_home_section_steps_lead = /** @type {(inputs: Home_Section_Steps_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hat lépés.`)
};

/**
* | output |
* | --- |
* | "Six steps." |
*
* @param {Home_Section_Steps_LeadInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const home_section_steps_lead = /** @type {((inputs?: Home_Section_Steps_LeadInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Section_Steps_LeadInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_section_steps_lead(inputs)
	if (locale === "de") return de_home_section_steps_lead(inputs)
	if (locale === "zh") return zh_home_section_steps_lead(inputs)
	if (locale === "ar") return ar_home_section_steps_lead(inputs)
	if (locale === "fr") return fr_home_section_steps_lead(inputs)
	if (locale === "vi") return vi_home_section_steps_lead(inputs)
	if (locale === "sw") return sw_home_section_steps_lead(inputs)
	if (locale === "th") return th_home_section_steps_lead(inputs)
	if (locale === "bs") return bs_home_section_steps_lead(inputs)
	if (locale === "ja") return ja_home_section_steps_lead(inputs)
	if (locale === "ko") return ko_home_section_steps_lead(inputs)
	if (locale === "pt") return pt_home_section_steps_lead(inputs)
	if (locale === "it") return it_home_section_steps_lead(inputs)
	if (locale === "sv") return sv_home_section_steps_lead(inputs)
	if (locale === "nl") return nl_home_section_steps_lead(inputs)
	if (locale === "da") return da_home_section_steps_lead(inputs)
	if (locale === "nb") return nb_home_section_steps_lead(inputs)
	if (locale === "fi") return fi_home_section_steps_lead(inputs)
	if (locale === "pl") return pl_home_section_steps_lead(inputs)
	if (locale === "ru") return ru_home_section_steps_lead(inputs)
	if (locale === "tr") return tr_home_section_steps_lead(inputs)
	if (locale === "hi") return hi_home_section_steps_lead(inputs)
	if (locale === "id") return id_home_section_steps_lead(inputs)
	if (locale === "ms") return ms_home_section_steps_lead(inputs)
	if (locale === "cs") return cs_home_section_steps_lead(inputs)
	if (locale === "el") return el_home_section_steps_lead(inputs)
	if (locale === "he") return he_home_section_steps_lead(inputs)
	if (locale === "af") return af_home_section_steps_lead(inputs)
	if (locale === "hu") return hu_home_section_steps_lead(inputs)
	return en_home_section_steps_lead(inputs)
});